module.exports = __webpack_public_path__ + "img/tobala_medal_show_case_with_medal.93965004.png";